<template>
  <div class="warp">
    <div class="content" v-if="ministate">
        <div class="title">金房宝</div>
        <div class="infor">
          <div class="sub-title">全民营销工具</div>
          <div class="content-intro">2015年，金地集团正式上线针对B端的产品金房宝。金房宝利用移动互联网建立起客户平台，通过微信社交圈，让每一个人都可以成为金地的销售员、宣传员 ，并通过业务的达成获取佣金等奖励。它是一款将人际网络与互联网完美结合的产物。金房宝的正式上线标志着金地集团进入全名营销时代的开始，意味着金地迈开了互联网战略至关重要的一步。</div>
          <div class="content-qr">体验小程序
            <div class="content-qr-pic"></div>
            <!-- <img  src="" > -->
          </div>
          <div class="content-logo" ></div>
          <!-- <img src=""> -->
        </div>
    </div>
    <div class="mini-content" v-else>
        <div class="mini-content-logo"></div>
        <!-- <img  src=""> -->
        <div class="mini-title">金房宝</div>
        <div class="mini-sub-title">全民营销工具</div>
        <div class="mini-content-intro">2015年，金地集团正式上线针对B端的产品金房宝。金房宝利用移动互联网建立起客户平台，通过微信社交圈，让每一个人都可以成为金地的销售员、宣传员 ，并通过业务的达成获取佣金等奖励。它是一款将人际网络与互联网完美结合的产物。金房宝的正式上线标志着金地集团进入全名营销时代的开始，意味着金地迈开了互联网战略至关重要的一步。</div>
        <div class="mini-img-warp">
          <div class="mini-qr-pic"></div>
          <img  src="" > 
        </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  components: {

    },
    data() {
        return {

        };
    },
    computed: {
      ...mapState(["screenWidth"]),
      ministate() {
          if (this.screenWidth >= 768) {
            return true 
          }else {
            return false
          }
      }
    },
}
</script>

<style scoped>
.warp {
  height: 100%;
}

.content {
  position: relative;
  width: 6.25rem;
  margin: .63rem auto 0;
}

.title {
  font-size: .25rem;
  font-weight: 700;
  color: #606060;
  margin-bottom: .06rem;
  padding-left: .09rem;
  border-left: .05rem solid #ff742b;;
}

.infor {
  margin-left: .14rem;
}

.sub-title {
  font-size: .17rem;
  font-weight: 400;
  color: #a8a8a8;
  margin-bottom: .16rem;
}

.content-intro {
  width: 3.33rem;
  line-height: .15rem;
  font-size: .1rem;
  font-weight: 400;
  color: #a8a8a8;
  margin-bottom: .31rem;
}

.content-qr {
  width: .86rem;
  height: .25rem;
  background: #ff7f3b;
  border-radius: .13rem;
  box-shadow: 0rem .01rem .07rem 0rem rgba(255,122,0,0.33); 
  font-size: .08rem;
  font-weight: 400;
  color: white;
  text-align: center;
  line-height: .26rem;
  overflow: hidden;
  transition: all 0.5s;
}

.content-qr:hover
{ 
  height: .86rem;
}

.content-qr-pic {
  margin: 0 auto ;
  width: .53rem;
  height: .53rem;
  /* background: cornflowerblue; */
  background-image: url(../imgs/mini-jfb-qr.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}


.content-logo {
  position: absolute;
  top: .14rem;
  right: .35rem;
  width: 1.32rem;
  height: 1.32rem;
  background-image: url(../imgs/mini-jfb.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

/* 移动端样式 */
.mini-content {
  height: 100%;
  display:flex;
  flex-direction: column;
  align-items: center;
}

.mini-content-logo {
  width: 2.67rem;
  height: 2.67rem;
  margin: 1.57rem  0 .67rem;
  background-image: url(../imgs/mini-jfb.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.mini-title {
  font-size: .48rem;
  font-weight: 700;
  color: #606060;
  margin-bottom: .27rem;
}

.mini-sub-title {
  font-size: .36rem;
  font-weight: 400;
  color: #a8a8a8;
  margin-bottom: .27rem;
}

.mini-content-intro {
  width: 7.24rem;
  font-size: .36rem;
  font-weight: 400;
  color: #CCC7C1;
  margin-bottom: .27rem;
  line-height: .4rem;
}

.mini-img-warp {
  width: 2.67rem;
  height: 2.67rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-radius: .2rem;
  box-shadow: 0 .03rem 10px 0 rgba(255,122,0,0.30); 
}

.mini-qr-pic {
  width: 2rem;
  height: 2rem;
  background-image: url(../imgs/mini-jfb-qr.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

</style>